<!-- <rx-col class="aic jcc" style="margin: 0 -20px;">
    <iframe width="100%" height="432" [src]="url" frameborder="0" allowfullscreen allow="autoplay"></iframe>
</rx-col>
 -->
<!-- <video *ngIf="url" controls>
    <source [src]="url">
</video> -->

<iframe
  *ngIf="url"
  width="100%"
  height="100%"
  [src]="url | safeUrl"
  title="YouTube video player"
  frameborder="0"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  allowfullscreen
></iframe>
